import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import "./info_chat.css";
//import { getContactData } from '../../providers/chatProvider';

class InfoChat extends Component {
  state = {
    professional: {}
  };

  async componentDidMount() {
    /* const chatId = this.props.match.params.chatId;
        const [ customer, professional ] = chatId.split('+');
        console.log(professional);
        const professionalData = await getContactData(professional);
        console.log(professionalData);
        this.setState({professional:professionalData}); */
  }

  render() {
    const {
      avatar,
      first_name,
      last_name,
      chat_price,
      video_price
    } = this.state.professional;
    return (
      <React.Fragment>
        <div className="d-flex flex-column align-items-center mb-3">
          <img className="foto" src={avatar} />
          <h3 className="nome">
            {first_name} {last_name}
          </h3>
        </div>
        <div>
          <p className="labels labels-info">
            Valor da Hora por chat:{" "}
            <span className="infos">R$ {chat_price}</span>
          </p>
          <p className="labels labels-info">
            Valor da hora por vídeo:{" "}
            <span className="infos">R$ {video_price}</span>
          </p>
          {/* <p className='labels labels-info'>Classificação: <span className='infos'>1° lugar</span></p> */}
          {/* <p className='labels labels-info'>Horário de Trabalho: <span className='infos'>8h-12h</span></p> */}
          {/* <p className='labels labels-info'>Clientes Satisfeitos: <span className='infos'>837</span></p> */}
          {/* <p className='labels labels-info'>Ingressou: <span className='infos'>há 6 meses</span></p> */}
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(InfoChat);
